// Shared "does this participant match the search chips" test, used by every
// tournament tab (Участники/Жеребкування/Розклад/Рейтинг) that highlights
// search matches instead of hiding non-matches outright - hiding would break
// the bracket's own connector lines between rounds and the groups matrix's
// row/col math, so every caller instead highlights matches and dims the
// rest.

// A single chip's own free-text/player-name test against whatever name(s)
// the caller's entity carries (a raw player object, a plain string, or
// several of either for doubles/teams). 'group'/'draw' chips are handled by
// chipsMatchEntity itself, not here - they don't test names at all.
export const chipMatchesNames = (chip, names) => {
    const q = (chip?.label || "").trim().toLowerCase();
    if (!q) return false;
    return (names || []).some(n => {
        if (!n) return false;
        if (typeof n === "string") return n.toLowerCase().includes(q);
        // Checked both word orders, not just "first last" - every options
        // list across the app (Schedule/Участники/Рейтинг/Жеребкування)
        // builds its player-chip labels as "last_name first_name", so a
        // selected suggestion's full-name label never matched here when
        // this only tried the reverse order (a query for just one of the
        // two names still happened to work either way, which is what let
        // this go unnoticed).
        const firstLast = `${n.first_name || ""} ${n.last_name || ""}`.toLowerCase();
        const lastFirst = `${n.last_name || ""} ${n.first_name || ""}`.toLowerCase();
        return firstLast.includes(q) || lastFirst.includes(q);
    });
};

// null = no active chips (render neutrally); true/false = match state once
// there are some. Chips OR together (matching ANY active chip highlights).
// groupValue/drawValue/stageValue are this entity's own group number /
// bracket (draw) number / schedule stage name, if it has one - entities
// with no such concept (Участники/Рейтинг rows) simply never match those
// chip types, which is the correct behavior there, not an error.
export const chipsMatchEntity = (chips, { names = [], groupValue, drawValue, stageValue } = {}) => {
    if (!chips || chips.length === 0) return null;
    return chips.some(chip => {
        if (chip.type === 'group') return groupValue != null && String(groupValue) === String(chip.realValue);
        if (chip.type === 'draw') return drawValue != null && String(drawValue) === String(chip.realValue);
        if (chip.type === 'stage') return stageValue != null && String(stageValue) === String(chip.realValue);
        return chipMatchesNames(chip, names);
    });
};

// matched (true/false/null, as returned above) -> the class to apply.
export const searchStateClass = (matched) =>
    matched === true ? "search-match" : matched === false ? "search-dim" : "";